export enum ManageParamTargetTypes {
  Node = 'node',
  Workflow = 'workflow',
  Endpoint = 'endpoint',
}
